import ACTIONS, { FETCH_STATUS } from '../app.constants';
import { Comment, CommentList, FilterCondition, Form } from '../modules/application/types';
import {
    LimitAndSkipData,
    TimeSheet,
    TimeSheetCountType,
    TimesheetType,
    TimeSheetCategory,
    ExpenseCategory,
} from '../modules/timeSheet/type';

export const getTimeSheetList = {
    pending: (data: LimitAndSkipData) => ({
        type: ACTIONS.TIME_SHEET_LIST.PENDING,
        status: FETCH_STATUS.LOADING,
        data,
    }),
    success: (data: TimeSheet[], limit: number, skip: number) => ({
        type: ACTIONS.TIME_SHEET_LIST.SUCCESS,
        payload: { data },
        limit,
        skip,
        status: FETCH_STATUS.SUCCESS,
    }),
    error: (error: Error) => ({
        type: ACTIONS.TIME_SHEET_LIST.ERROR,
        status: FETCH_STATUS.ERROR,
        error,
    }),
};

export const getTimeSheetListCount = {
    pending: (data: LimitAndSkipData) => ({
        type: ACTIONS.SET_TIME_SHEET_LIST_COUNT.PENDING,
        data,
        status: FETCH_STATUS.LOADING,
    }),
    success: (timeSheetCount: TimeSheetCountType) => ({
        type: ACTIONS.SET_TIME_SHEET_LIST_COUNT.SUCCESS,
        timeSheetCount,
        status: FETCH_STATUS.SUCCESS,
    }),
    error: (error: Error) => ({
        type: ACTIONS.SET_TIME_SHEET_LIST_COUNT.ERROR,
        error,
        status: FETCH_STATUS.ERROR,
    }),
};

export const getTimeSheetTypes = {
    pending: {
        type: ACTIONS.GET_TIME_SHEET_TYPES.PENDING,
        status: FETCH_STATUS.LOADING,
    },
    success: (data: TimesheetType[], editForm: Form) => ({
        type: ACTIONS.GET_TIME_SHEET_TYPES.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
        payload: { data, editForm },
    }),
    error: (error: Error) => ({
        type: ACTIONS.GET_TIME_SHEET_TYPES.ERROR,
        status: FETCH_STATUS.ERROR,
        error,
    }),
};

export const getTimeSheetDetails = {
    pending: {
        type: ACTIONS.GET_TIME_SHEET_DETAILS.PENDING,
        status: FETCH_STATUS.LOADING,
    },
    success: (data: TimeSheet) => ({
        type: ACTIONS.GET_TIME_SHEET_DETAILS.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
        payload: data,
    }),
    error: (error: Error) => ({
        type: ACTIONS.GET_TIME_SHEET_DETAILS.ERROR,
        status: FETCH_STATUS.ERROR,
        error,
    }),
};

export const getTimeSheetCategories = {
    pending: {
        type: ACTIONS.GET_TIME_SHEET_CATEGORIES.PENDING,
        status: FETCH_STATUS.LOADING,
    },
    success: (data: TimeSheetCategory[]) => ({
        type: ACTIONS.GET_TIME_SHEET_CATEGORIES.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
        payload: data,
    }),
    error: (error: Error) => ({
        type: ACTIONS.GET_TIME_SHEET_CATEGORIES.ERROR,
        status: FETCH_STATUS.ERROR,
        error,
    }),
};

export const openTimeCards = {
    pending: {
        type: ACTIONS.OPEN_TIME_SHEET_FOR_SELECTED_DATE.PENDING,
        status: FETCH_STATUS.LOADING,
    },
    success: (data: TimeSheet) => ({
        type: ACTIONS.OPEN_TIME_SHEET_FOR_SELECTED_DATE.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
        payload: data,
    }),
    error: (error: Error) => ({
        type: ACTIONS.OPEN_TIME_SHEET_FOR_SELECTED_DATE.ERROR,
        status: FETCH_STATUS.ERROR,
        error,
    }),
};
export const getAppointmentsBySelectedDate = {
    pending: {
        type: ACTIONS.GET_APPOINTMENT_BY_SELECTED_DATE.PENDING,
        status: FETCH_STATUS.LOADING,
    },
    success: (data: any) => ({
        type: ACTIONS.GET_APPOINTMENT_BY_SELECTED_DATE.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
        payload: data,
    }),
    error: (error: Error) => ({
        type: ACTIONS.GET_APPOINTMENT_BY_SELECTED_DATE.ERROR,
        status: FETCH_STATUS.ERROR,
        error,
    }),
};

export const getTimeSheetExpenseCategories = {
    pending: {
        type: ACTIONS.GET_TIME_SHEET_EXPENSE_CATEGORIES.PENDING,
        status: FETCH_STATUS.LOADING,
    },
    success: (data: ExpenseCategory[]) => ({
        type: ACTIONS.GET_TIME_SHEET_EXPENSE_CATEGORIES.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
        payload: data,
    }),
    error: (error: Error) => ({
        type: ACTIONS.GET_TIME_SHEET_EXPENSE_CATEGORIES.ERROR,
        status: FETCH_STATUS.ERROR,
        error,
    }),
};

export const getTimeSheetCommentList = {
    pending: {
        type: ACTIONS.GET_TIME_SHEET_COMMENT_LIST.PENDING,
        status: FETCH_STATUS.LOADING,
    },
    success: (data: CommentList) => ({
        type: ACTIONS.GET_TIME_SHEET_COMMENT_LIST.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
        payload: data,
    }),
    error: (error: Error) => ({
        type: ACTIONS.GET_TIME_SHEET_COMMENT_LIST.ERROR,
        status: FETCH_STATUS.ERROR,
        error,
    }),
};

export const addTimeSheetComment = {
    pending: {
        type: ACTIONS.ADD_TIME_SHEET_COMMENT.PENDING,
        status: FETCH_STATUS.LOADING,
    },
    success: (comment: Comment) => ({
        type: ACTIONS.ADD_TIME_SHEET_COMMENT.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
        payload: { data: [comment] },
    }),
    error: (error: Error) => ({
        type: ACTIONS.ADD_TIME_SHEET_COMMENT.ERROR,
        error,
        status: FETCH_STATUS.ERROR,
    }),
};

export const saveTimeSheet = {
    pending: {
        type: ACTIONS.SAVE_TIME_SHEET.PENDING,
        status: FETCH_STATUS.LOADING,
    },
    success: (result: TimeSheet) => ({
        type: ACTIONS.SAVE_TIME_SHEET.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
        payload: result,
    }),
    error: (error: Error) => ({
        type: ACTIONS.SAVE_TIME_SHEET.ERROR,
        error,
        status: FETCH_STATUS.ERROR,
    }),
};

export const mergeTimesheetDocuments = {
    pending: {
        type: ACTIONS.DOWNLOAD_TIMESHEET_PACKET.PENDING,
        status: FETCH_STATUS.LOADING,
    },
    success: (data: any) => ({
        type: ACTIONS.DOWNLOAD_TIMESHEET_PACKET.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
        data,
    }),
    error: (error: Error) => ({
        type: ACTIONS.DOWNLOAD_TIMESHEET_PACKET.ERROR,
        status: FETCH_STATUS.ERROR,
        error,
    }),
};

export const getTimesheetSearchForm = {
    pending: {
        type: ACTIONS.GET_TIMESHEET_SEARCH_FORM.PENDING,
        status: FETCH_STATUS.LOADING,
    },
    success: (searchForm: Form) => ({
        type: ACTIONS.GET_TIMESHEET_SEARCH_FORM.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
        data: searchForm,
    }),
    error: (error: Error) => ({
        type: ACTIONS.GET_TIMESHEET_SEARCH_FORM.ERROR,
        status: FETCH_STATUS.ERROR,
        error,
    }),
};

export const applyTimesheetFilters = (data: FilterCondition[], paginationData: LimitAndSkipData) => {
    return {
        type: ACTIONS.APPLY_TIMESHEET_FILTERS,
        payload: { data },
        data: paginationData,
    };
};

export const getTimeSheetListBegin = (data: LimitAndSkipData, listFilters: FilterCondition[]) => {
    return {
        type: ACTIONS.TIME_SHEET_LIST_BEGIN,
        status: true,
        data,
        payload: { data: listFilters },
    };
};

export const setTimeSheetFilterSelections = (data: Record<string, string | string[]>) => {
    return {
        type: ACTIONS.SET_TIMESHEET_FILTERS_SELECTION,
        payload: { data },
    };
};

export const getTimeSheetTypesBegin = (id: string) => {
    return {
        type: ACTIONS.GET_TIME_SHEET_TYPES_BEGIN,
        payload: { id },
    };
};

export const getTimeSheetCategoriesBegin = () => {
    return {
        type: ACTIONS.GET_TIME_SHEET_CATEGORIES_BEGIN,
    };
};

export const getTimeSheetDetailsBegin = (timeSheetId: string) => {
    return {
        type: ACTIONS.GET_TIME_SHEET_DETAILS_BEGIN,
        payload: { params: { timeSheetId } },
    };
};

export const openTimeSheetForSelectedDateBegin = (selectedDate: string) => {
    return {
        type: ACTIONS.OPEN_TIME_SHEET_FOR_SELECTED_DATE_BEGIN,
        payload: { params: { selectedDate } },
    };
};

export const getAppointmentsBySelectedDateBegin = (selectedDate: string, timeSheetUserId: string) => {
    return {
        type: ACTIONS.GET_APPOINTMENT_BY_SELECTED_DATE_BEGIN,
        payload: { params: { timeSheetUserId, selectedDate } },
    };
};

export const setSelectedTimeSheetDate = (selectedDate: string) => {
    return {
        type: ACTIONS.SET_TIME_SHEET_SELECTED_DATE,
        payload: selectedDate,
    };
};

export const getTimeSheetExpenseCategoriesBegin = () => {
    return {
        type: ACTIONS.GET_TIME_SHEET_EXPENSE_CATEGORIES_BEGIN,
    };
};

export const AddTimeSheetCommentBegin = (comment: string, timeSheetId: string) => {
    return {
        type: ACTIONS.ADD_TIME_SHEET_COMMENT_BEGIN,
        payload: { comment, timeSheetId },
    };
};

export const getTimeSheetCommentListBegin = (id: string) => {
    return {
        type: ACTIONS.GET_TIME_SHEET_COMMENT_LIST_BEGIN,
        payload: { id },
    };
};

export const saveTimeSheetBegin = (
    timeSheet: TimeSheet,
    timeSheetId: string,
    displayMessage: string,
    listFilters: FilterCondition,
) => {
    return {
        type: ACTIONS.SAVE_TIME_SHEET_BEGIN,
        payload: { params: { timeSheet, timeSheetId, displayMessage, listFilters } },
    };
};

export const mergeTimesheetDocumentsBegin = (templateId: string, fileName: string, timesheetId: string) => {
    return {
        type: ACTIONS.DOWNLOAD_TIMESHEET_PACKET_BEGIN,
        payload: { templateId, fileName, timesheetId },
    };
};

export const getTimesheetSearchConfiguredFormBegin = () => {
    return {
        type: ACTIONS.GET_TIMESHEET_SEARCH_FORM_BEGIN,
    };
};
